import script from "./appNav.vue?vue&type=script&setup=true&lang=js"
export * from "./appNav.vue?vue&type=script&setup=true&lang=js"

import "./appNav.vue?vue&type=style&index=0&id=601f6a74&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-601f6a74"]])

export default __exports__